module.exports = __webpack_public_path__ + "img/golomtpay.228f4544.png";